import { render, staticRenderFns } from "./membermanagement.vue?vue&type=template&id=2452d338&scoped=true&"
import script from "./membermanagement.vue?vue&type=script&lang=js&"
export * from "./membermanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452d338",
  null
  
)

export default component.exports